export class DarkWebItem {
  program: string;
  price: number;
  description: string;

  constructor(program: string, price: number, description: string) {
    this.program = program;
    this.price = price;
    this.description = description;
  }
}
